const portalNavItems = [
    { "name": "Quote Request Form", "url": "/portal", "subLinks": null },
    { "name": "Requests", "url": "/portal/requests", "subLinks": null },
    { "name": "Trips / Requests", "url": "/portal/trips", "subLinks": null },
    { "name": "Contracts & Payments", "url": "/portal/contracts", "subLinks": null },
    { "name": "Bookings", "url": "/portal/bookings", "subLinks": null }
]

export {portalNavItems}